export const visit = (vm, at) => {
at({ "en": { "composer-ui": { "reply-recommendations": { "title": "Reply Recommendation", "edit": "Edit", "dismiss": "Dismiss", "citations": { "popoverHeader": "Sources", "button": "Sources", "copied": "Source Copied" } } } } });
};